module.exports = __webpack_public_path__ + "static/img/text02.aea6456.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert/text02.jpg
// module id = wL78
// module chunks = 126